import { Pipe, PipeTransform } from '@angular/core';
import { LocationDto } from '@lib-ui/client';
import { getGoogleMapsLinkFromAddress } from '@lib-ui/lib/functions';

@Pipe({
  name: 'mapLink',
  standalone: true,
})
export class MapLinkPipe implements PipeTransform {

  transform(location: LocationDto): string {
    return getGoogleMapsLinkFromAddress(location);
  }
}
